<template>
    <div>
        <div class="laddressFirst">
            <div class="laddressFirstLeft">编辑地址</div>
            <div class="laddressFirstBtn" @click="Return()">返回</div>
        </div>
        <div class="changePasswordForm">

            <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
                <FormItem label="省市县" required>
                     <Select v-model="formCustom.sheng" style="width: 160px" placeholder="请选择省份" @on-change="changesheng()">
                          <Option v-for="(item, index) in provinceArr" :key="index" :value="item.text">{{ item.text }}</Option>
                    </Select>
                       <Select v-model="formCustom.shi" style="width: 160px" placeholder="请选择城市" @on-change="changeCity(formCustom.shi)"> 
                        <Option v-for="(item, index) in citiesArr" :key="index" :value="item.text">{{ item.text }}</Option>
                    </Select> 
                    <Select v-model="formCustom.qu" style="width: 160px" placeholder="请选择区县" @on-change="getpost(formCustom.qu)">
                           <Option v-for="(item, index) in countyArr" :key="index" :value="item.text">{{ item.text }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="邮寄地址" prop="newaddress">
                    <Input type="text" placeholder="请输入新的邮寄地址" v-model="formCustom.newaddress"></Input>
                </FormItem>
                <FormItem label="邮编" prop="youbian">
                    <Input type="text" placeholder="请输入邮编" v-model="formCustom.youbian"></Input>
                </FormItem>
                <FormItem label="收货人" prop="receiver">
                    <Input type="text" placeholder="请输入收货人" v-model="formCustom.receiver"></Input>
                </FormItem>
                <FormItem label="手机号" prop="mobile">
                    <Input type="text" placeholder="请输入手机号" v-model="formCustom.mobile"></Input>
                </FormItem>
            </Form>
            <Button type="primary" @click="Submit()" class="btt">提交</Button>
        </div>
    </div>
</template>
<script>
    import Cookies from "js-cookie";
    import { getNews, editAddress } from "../../../network/LPersonal";
    import {
        getCityList
    } from "../../../network/home";
    export default {
        data() {
            return {
                obj: {},
                formCustom: {
                    newaddress: "",
                    youbian: "",
                    sheng: "",
                    shi: "",
                    qu: "",
                },
                provinceArr: [],
                citiesArr: [],
                countyArr: [],
                ruleCustom: {
                    newaddress: [{
                        required: true,
                        message: "请输入新的邮寄地址",
                        trigger: "blur",
                    }, ],
                    youbian: [{
                        required: true,
                        message: "请输入邮编",
                        trigger: "blur"
                    }, ],
                    sheng: [{
                        required: true,
                        message: "请输入省",
                        trigger: "blur"
                    }, ],
                    receiver: [{
                        required: true,
                        message: "请输入收货人",
                        trigger: "blur"
                    }],
                    mobile: [{
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur"
                    }],
                    shi: [{
                        required: true,
                        message: "请输入市",
                        trigger: "blur"
                    }],
                    he: [{
                        required: true,
                        trigger: "change"
                    }],
                },
            };
        },
        methods: {
            Return() {
                this.$router.go(-1);
            },
            Get(name) {
                return Cookies.get(`admin-${name}`);
            },
            Submit() {
                this.$refs.formCustom.validate((valid) => {
                    if(valid){
                        this.editAddress();
                    }
                    else{
                        this.$message.error('请输入完整信息');
                        return
                    }
                })
            },
            editAddress() {
                editAddress({
                    address: this.formCustom.newaddress,
                    userId: this.Get("userId"),
                    postalCode: this.formCustom.youbian,
                    province: this.formCustom.sheng,
                    receiver: this.formCustom.receiver,
                    mobile: this.formCustom.mobile,
                    city: this.formCustom.shi,
                    county: this.formCustom.qu,
                    isDefault: this.formCustom.isDefault,
                    id: this.formCustom.id
                }).then((r) => {
                    console.log(r);
                    if (r.data.code == 200) {
                        this.$message.success(r.data.msg);
                        this.$router.go(-1)
                    } else {
                        this.$message.error(r.data.msg);
                    }
                });
            },

            get() {
                getNews({
                    userId: this.Get("userId"),
                }).then((r) => {
                    console.log(r, "个人信息");
                    this.formItem = r.data.data;
                    // console.log(this.formItem.user.idCard);
                });
            },
            changesheng() {
                this.citiesArr = this.provinceArr[0].children;
                this.comProvincecode = this.provinceArr[0].code;
            },
            changeCity(e) {
                console.log(e);
                this.citiesArr.forEach((item, i) => {
                    if (e == this.citiesArr[i].text) {
                        this.countyArr = this.citiesArr[i].children;
                        console.log(this.countyArr);
                        this.comCitycode = this.citiesArr[i].code;
                    }
                });
            },
            getpost(e) {
                console.log(e);
                this.countyArr.forEach((item, i) => {
                    if (e == this.countyArr[i].text) {
                        this.formCustom.youbian = this.countyArr[i].postCode;
                        this.youbian = this.countyArr[i].code;
                    }
                });
            },
            queryProvince() {
                getCityList().then((res) => {
                    console.log(res, "省");
                    this.provinceArr = res.data.data;
                    this.changesheng();
                    this.changeCity(this.formCustom.shi);
                    this.getpost(formCustom.qu);
                });
            },
        },
        created() {
            this.get();
            this.queryProvince();
            this.obj = JSON.parse(decodeURIComponent(this.$route.query.data));
            this.formCustom.newaddress = this.obj.address;
            this.formCustom.shi = this.obj.city;
            this.formCustom.sheng = this.obj.province;
            this.formCustom.qu = this.obj.county;
            this.formCustom.isDefault = this.obj.isDefault == true ? 1 : 0;
            this.formCustom.youbian = this.obj.postalCode;
            this.formCustom.id = this.obj.id;
            this.formCustom.mobile = this.obj.mobile;
            this.formCustom.receiver = this.obj.receiver;
        },
    };
</script>
<style scoped>
    .btt {
        margin-left: 200px;
    }
</style>